import type {MetlJobsTree, MetlJobsTreeJob} from "../debug/MetlJobsTree.ts";

export function flattenMetlJobsTree(jobsTree: MetlJobsTree): MetlJobsTreeJob[] {
    return [...jobsTree.jobs, ...jobsTree.children.flatMap(flattenMetlJobsTree)]
}